import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '../ui/Icon';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  return <AnimatePresence data-id="element-110">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-111" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-112">
            <div className="flex min-h-full items-center justify-center p-4" data-id="element-113">
              <motion.div initial={{
            opacity: 0,
            scale: 0.95,
            y: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95,
            y: 20
          }} className="relative bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-hidden" data-id="element-114">
                {/* Header */}
                <div className="sticky top-0 bg-gradient-to-r from-black to-gray-900 text-white px-6 py-4 flex items-center justify-between border-b border-yellow-500/30" data-id="element-115">
                  <h2 className="text-2xl font-bold" data-id="element-116">Política de Privacidad</h2>
                  <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors" aria-label="Cerrar" data-id="element-117">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-118">
                      <line x1="18" y1="6" x2="6" y2="18" data-id="element-119" />
                      <line x1="6" y1="6" x2="18" y2="18" data-id="element-120" />
                    </svg>
                  </button>
                </div>

                {/* Content */}
                <div className="px-6 py-8 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-121">
                  <div className="prose prose-gray max-w-none" data-id="element-122">
                    <p className="text-sm text-gray-500 mb-6" data-id="element-123">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                    </p>

                    <section className="mb-8" data-id="element-124">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-125">
                        1. Información que Recopilamos
                      </h3>
                      <p className="text-gray-700 leading-relaxed mb-4" data-id="element-126">
                        Recopilamos información que usted nos proporciona
                        directamente cuando se registra en nuestros servicios,
                        incluyendo:
                      </p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-127">
                        <li data-id="element-128">
                          Nombre completo y dirección de correo electrónico
                        </li>
                        <li data-id="element-129">Información de pago y facturación</li>
                        <li data-id="element-130">Comunicaciones que mantiene con nosotros</li>
                        <li data-id="element-131">Información sobre su uso de nuestros servicios</li>
                      </ul>
                    </section>

                    <section className="mb-8" data-id="element-132">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-133">
                        2. Uso de la Información
                      </h3>
                      <p className="text-gray-700 leading-relaxed mb-4" data-id="element-134">
                        Utilizamos la información recopilada para:
                      </p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-135">
                        <li data-id="element-136">
                          Proporcionar, mantener y mejorar nuestros servicios
                        </li>
                        <li data-id="element-137">
                          Procesar transacciones y enviar información
                          relacionada
                        </li>
                        <li data-id="element-138">
                          Enviar comunicaciones técnicas, actualizaciones y
                          mensajes administrativos
                        </li>
                        <li data-id="element-139">
                          Responder a sus comentarios, preguntas y solicitudes
                          de atención al cliente
                        </li>
                        <li data-id="element-140">
                          Enviarle información de marketing con su
                          consentimiento
                        </li>
                        <li data-id="element-141">
                          Monitorear y analizar tendencias, uso y actividades
                        </li>
                      </ul>
                    </section>

                    <section className="mb-8" data-id="element-142">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-143">
                        3. Compartir Información
                      </h3>
                      <p className="text-gray-700 leading-relaxed mb-4" data-id="element-144">
                        No vendemos ni alquilamos su información personal a
                        terceros. Podemos compartir su información en las
                        siguientes circunstancias:
                      </p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-145">
                        <li data-id="element-146">
                          Con proveedores de servicios que nos ayudan a operar
                          nuestro negocio
                        </li>
                        <li data-id="element-147">Para cumplir con obligaciones legales</li>
                        <li data-id="element-148">Para proteger nuestros derechos y propiedad</li>
                        <li data-id="element-149">Con su consentimiento explícito</li>
                      </ul>
                    </section>

                    <section className="mb-8" data-id="element-150">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-151">
                        4. Seguridad de Datos
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-152">
                        Implementamos medidas de seguridad técnicas y
                        organizativas apropiadas para proteger su información
                        personal contra acceso no autorizado, alteración,
                        divulgación o destrucción. Sin embargo, ningún método de
                        transmisión por Internet o almacenamiento electrónico es
                        100% seguro.
                      </p>
                    </section>

                    <section className="mb-8" data-id="element-153">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-154">
                        5. Sus Derechos
                      </h3>
                      <p className="text-gray-700 leading-relaxed mb-4" data-id="element-155">
                        Usted tiene derecho a:
                      </p>
                      <ul className="list-disc pl-6 text-gray-700 space-y-2" data-id="element-156">
                        <li data-id="element-157">Acceder a su información personal</li>
                        <li data-id="element-158">Corregir información inexacta</li>
                        <li data-id="element-159">Solicitar la eliminación de su información</li>
                        <li data-id="element-160">Oponerse al procesamiento de su información</li>
                        <li data-id="element-161">Solicitar la portabilidad de sus datos</li>
                        <li data-id="element-162">Retirar su consentimiento en cualquier momento</li>
                      </ul>
                    </section>

                    <section className="mb-8" data-id="element-163">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-164">
                        6. Cookies y Tecnologías Similares
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-165">
                        Utilizamos cookies y tecnologías similares para
                        recopilar información sobre su actividad en nuestro
                        sitio web. Puede controlar el uso de cookies a través de
                        la configuración de su navegador.
                      </p>
                    </section>

                    <section className="mb-8" data-id="element-166">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-167">
                        7. Cambios a esta Política
                      </h3>
                      <p className="text-gray-700 leading-relaxed" data-id="element-168">
                        Podemos actualizar esta política de privacidad
                        periódicamente. Le notificaremos sobre cambios
                        significativos publicando la nueva política en esta
                        página y actualizando la fecha de "última
                        actualización".
                      </p>
                    </section>

                    <section className="mb-8" data-id="element-169">
                      <h3 className="text-xl font-bold text-black mb-4" data-id="element-170">
                        8. Contacto
                      </h3>
                      <p className="text-gray-700 leading-relaxed mb-4" data-id="element-171">
                        Si tiene preguntas sobre esta política de privacidad o
                        sobre nuestras prácticas de datos, puede contactarnos
                        en:
                      </p>
                      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-172">
                        <p className="text-gray-700 font-medium" data-id="element-173">
                          Email:{' '}
                          <a href="mailto:support@truemarketer.com" className="text-yellow-600 hover:text-yellow-700 font-semibold" data-id="element-174">
                            support@truemarketer.com
                          </a>
                        </p>
                      </div>
                    </section>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </>}
    </AnimatePresence>;
}